<template>
  <div class="center_box">
    <Header style="margin-top:30px;"></Header>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link to="/">{{$t('message.homepage')}}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.product')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('message.title_02')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div><h1 style="font-size:34px;padding-top:20px;padding-bottom:20px;">{{$t('message.title_02')}}</h1></div>
    <SelectedSeries v-on:listenPageChange="listenPageChange" v-on:listenParam="listenParam" v-show="SeriesPage"></SelectedSeries>
    <SelectedLoad ref="SelectedLoad" v-on:listenPageChange="listenPageChange" v-on:listenParam_2="listenParam_2" v-show="LoadPage" :param_1="param_1"></SelectedLoad>
    <SelectedSize ref="SelectedSize" v-on:listenPageChange="listenPageChange" v-on:listenParam_3="listenParam_3" v-show="SizePage" :param_1="param_1" :param_2="param_2"></SelectedSize>
    <SelectedMotor ref="SelectedMotor" v-on:listenPageChange="listenPageChange" v-on:listenParam_4="listenParam_4" :param_3="param_3" v-show="MotorPage"></SelectedMotor>
    <SelectedCompleted ref="SelectedCompleted" v-on:listenPageChange="listenPageChange" :param_4="param_4" v-show="CompletedPage"></SelectedCompleted>
    <BackTop></BackTop>
  </div>
</template>
<script>
import Header from '../Header'
import BackTop from '../BackTop'
import SelectedSeries from './SelectedSeries'
import SelectedLoad from './SelectedLoad'
import SelectedSize from './SelectedSize'
import SelectedMotor from './SelectedMotor'
import SelectedCompleted from './SelectedCompleted'
export default {
  name: 'LoadSelection',
  components: {
    SelectedSeries,
    SelectedLoad,
    SelectedSize,
    SelectedMotor,
    SelectedCompleted,
    BackTop,
    Header
  },
  data () {
    return {
      SeriesPage:true,
      LoadPage:false,
      SizePage:false,
      MotorPage:false,
      CompletedPage:false,
      param_1:{},
      param_2:{},
      param_3:{},
      param_4:{}
    }
  },
  methods:{
    listenPageChange:function(data) {
      if(data === 'to_LoadPage'){
        //执行子组件方法
        this.$refs.SelectedLoad._getreductionratiolist();

        this.SeriesPage = false;
        this.LoadPage = true;
        this.SizePage = false;
        this.MotorPage = false;
        this.CompletedPage = false;
      }else if(data === 'to_SeriesPage'){
        this.SeriesPage = true;
        this.LoadPage = false;
        this.SizePage = false;
        this.MotorPage = false;
        this.CompletedPage = false;
      }else if(data === 'to_SizePage'){
        //执行子组件的方法
        this.$refs.SelectedSize._getListReducerisAble();
        this.SeriesPage = false;
        this.LoadPage = false;
        this.SizePage = true;
        this.MotorPage = false;
        this.CompletedPage = false;
      }else if(data === 'to_MotorPage'){
        //执行子组件的方法
        this.$refs.SelectedMotor._getavailablemotorfactory();
        this.SeriesPage = false;
        this.LoadPage = false;
        this.SizePage = false;
        this.MotorPage = true;
        this.CompletedPage = false;
      }else if(data === 'to_CompletedPage'){
        //执行子组件的方法
        this.$refs.SelectedCompleted._getinfobyreducersize();
        this.$refs.SelectedCompleted._getinfobyfactoryandsize();

        this.SeriesPage = false;
        this.LoadPage = false;
        this.SizePage = false;
        this.MotorPage = false;
        this.CompletedPage = true;
      }
    },
    listenParam:function(data){
      if(data){
        this.param_1.reducer_series_name = data;
      }
    },
    listenParam_2:function(data){
      this.param_2.array = data;
    },
    listenParam_3:function(data){
      this.param_3.reducer_size = data;
    },
    listenParam_4:function(data){
      this.param_4.reducer_size = this.param_3.reducer_size
      this.param_4.motor_factory = data.motor_factory;
      this.param_4.motor_type = data.motor_type;
    }
  }
}
</script>
<style scoped>
  .center_box {
    width:75%;
    margin:0 auto;
    height:100%;
  }
  .el-breadcrumb {
    font-size: 18px;
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/LoadSelection/LoadSelection.vue